import { useLocation, useNavigate } from "react-router-dom";
import TabBar from "@shared/v2/TabBar/TabBar";
import Tab from "@shared/v2/Tab/Tab";

export const TEMPLATE_TABS = [
  { path: "email", label: "Email" },
  { path: "text", label: "Text" },
  { path: "listing-alerts", label: "Listing Alerts" },
];

const TemplatesTabs = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const current = pathname.replace(/^\//, "").split("/")[0];

  return (
    <TabBar>
      {TEMPLATE_TABS.map(({ path, label }) => (
        // @ts-expect-error props
        <Tab
          key={path}
          label={label}
          selected={current === path}
          onClick={() => {
            if (current !== path) navigate(`/${path}`);
          }}
        />
      ))}
    </TabBar>
  );
};

export default TemplatesTabs;
